import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { handleAuth } from "../../../../src/components/Login/Auth";
import moment from "moment";
import { formatDateWithTime } from "../../../utils/dateUtils.js";
import { useUserTimezoneFormatter } from "../../../components/UserTimezoneDateFormatter/UserTimezoneDateFormatter";
import CustomSwal from "../../../components/Swal/CustomSwal";
import showToast from "../../../components/Toast/Toster";
import * as Yup from "yup";
import { DeleteIcone, EditIcon } from "../../../components/Icon/Index";
import { Grid, Menu, MenuItem, IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";
import PaymentIcon from "@mui/icons-material/Payment";
import { Col } from "reactstrap";
import { Typography } from "@mui/material";
import RecurringPayment from "./Views/RecurringPledges";
import { useFormik } from "formik";
import DialogComponent from "../../../components/Dialog/Dialog";
import {
  getCardDetails,
  getCardLogo,
  getCardType,
  getRecurringCards,
  getTokenizationKeyCustomer,
} from "../../../plugins/ApiHandler";
import AxiosInstance from "../../AxiosInstance";
import { getItem } from "../../../utils/storage";
import {
  getGatewayForPaymentMethod,
  isDejavooGateway,
} from "../../../utils/gatewayHelper";

function RecurringPayments() {
  const [tokenDecode, setTokenDecode] = useState({});
  
  const [isDonationMode, setIsDonationMode] = useState(true);
  const [transactionFeePercentage, setTransactionFeePercentage] = useState(0);
  const location = useLocation();
  const { companyName } = useParams();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [loading, setLoading] = useState(true);
  const [submitloading, setsubmitLoading] = useState(false);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [customersData, setcustomersData] = useState([]);
  const [countData, setCountData] = useState(0);
  const [Singlerecurringcharge, setSinglerecurringcharge] = useState(false);
  const SinglecardToggle = () =>
    setSinglerecurringcharge(!Singlerecurringcharge);
  const [recurringChargeId, setRecurringChargeId] = useState("");
  const [recurringId, setRecurringId] = useState("");
  const CompanyId = tokenDecode?.CompanyId;
  // Use tokenDecode?.UserId so recurring CustomerId matches vault (same as Make Donation / card-on-file)
  const CustomerId = tokenDecode?.UserId || getItem("DonorId");
  const [selectedAccountId, setSelectedAccountId] = useState("");
  const [selectedFrequency, setSelectedFrequency] = useState("");
  const [AssetAccounts, setAssetAccounts] = useState([]);
  const [frequencyDropdownOpen, setFrequencyDropdownOpen] = useState(false);
  const [weekdayDropdownOpen, setWeekdayDropdownOpen] = useState(false);
  const [applyTransactionFee, setApplyTransactionFee] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [dateDecode, setDateDecode] = useState("MM/DD/YYYY hh:mm");
  const [dateFormat, setDateFormat] = useState("MM/DD/YYYY hh:mm");
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");

  const cardGateway = useMemo(
    () => getGatewayForPaymentMethod(tokenDecode, "Credit/debit card"),
    [tokenDecode]
  );
  const requiresSavedCard = !isDejavooGateway(cardGateway);

    const handleTransactionFeeChange = (event) => {
    setApplyTransactionFee(event.target.checked);
    if (
      event.target.checked &&
      isDonationMode &&
      transactionFeePercentage > 0
    ) {
    } else {
    }
  };

  const toggleWeekdayDropdown = () =>
    setWeekdayDropdownOpen(!weekdayDropdownOpen);
  const [selectChargeDropDown, setSelectChargetDropDown] = useState(false);
  const toggles1 = () => setSelectChargetDropDown(!selectChargeDropDown);
  const toggleFrequencyDropdown = () =>
    setFrequencyDropdownOpen(!frequencyDropdownOpen);
  const [addBankAccountDialogOpen, setAddBankAccountDialogOpen] =
    useState(false);

  const [timeFormat, setTimeFormat] = useState("12h");
  
  // Use timezone-aware date formatter hook
  const formatDateWithUserTimezone = useUserTimezoneFormatter();
  
  const fetchDateFormat = async () => {
    try {
      const res = await handleAuth(navigate, location);
      setDateDecode(res?.themes);
      const timeFormatSetting = res?.data?.TimeFormat || "12h";
      setTimeFormat(timeFormatSetting);
    } catch (error) {
      console.error("Error fetching date format:", error);
      setTimeFormat("12h");
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      try {
        const authRes = await handleAuth(navigate, location);
        if (!authRes?.data) {
          throw new Error("No auth data received");
        }
        setTokenDecode(authRes?.data);

        if (authRes?.data?.CompanyId) {
          const companyRes = await AxiosInstance.get(
            `v1/user/company-profile/${authRes?.data?.CompanyId}`
          );

          if (companyRes?.data?.data?.user) {
            const {
              transactionFeePercentage: fee,
              IsDonationMode: donationMode,
            } = companyRes?.data?.data?.user;
            setTransactionFeePercentage(fee || 0);
            setIsDonationMode(donationMode !== false); // Default to true for donor portal
          } else {
            console.warn(
              "Company data not in expected format:",
              companyRes?.data
            );
          }
        }
      } catch (error) {
        console.error("Error in initialization:", error);
        if (error.message === "No auth data received") {
          showToast.error("Authentication failed");
        } else {
          showToast.error("Unable to fetch company settings");
        }
      }
    };

    initializeData();
    fetchDateFormat();
  }, []);

  
  useEffect(() => {
    const handleDateFormat = () => {
      
      if (dateDecode?.Format) {
        try {
          const testDate = moment().format(dateDecode.Format);
          
          if (testDate && testDate !== "Invalid date") {
           
            const formatString = dateDecode.Format;
            let finalFormat = formatString;
            
            
            if (!formatString.includes('h') && !formatString.includes('H') && 
                !formatString.includes('m') && !formatString.includes('s')) {
              finalFormat = formatString + " hh:mm";
              
            }
            
            
            setDateFormat(finalFormat);
          } else {
            console.warn('Invalid date format from backend, using default:', dateDecode.Format);
            setDateFormat("MM/DD/YYYY hh:mm");
          }
        } catch (error) {
          console.warn('Error validating date format, using default:', error);
          setDateFormat("MM/DD/YYYY hh:mm");
        }
      } else {
        
        setDateFormat("MM/DD/YYYY hh:mm");
      }
    };

    handleDateFormat();
  }, [dateDecode]);

  
  useEffect(() => {
    
  }, [dateFormat]);

  
  const formatDate = (date) => {
    if (!date) return "-";
    try {
      // Remove time format from dateFormat to show only date
      const dateOnlyFormat = dateFormat.replace(/\s*h{1,2}:mm\s*[aApP][mM]\s*/gi, "").replace(/\s*H{1,2}:mm\s*/gi, "").replace(/\s*:ss\s*/gi, "").trim();
      return formatDateWithUserTimezone(date, {
        dateFormat: dateOnlyFormat || "MM/DD/YYYY",
        excludeTime: true
      });
    } catch (error) {
      console.error('Error formatting date:', error);
      return formatDateWithUserTimezone(date, {
        dateFormat: "MM/DD/YYYY",
        excludeTime: true
      });
    }
  };

  const fetchAccounts = async () => {
    if (tokenDecode?.CompanyId) {
      try {
        const res = await AxiosInstance.get(
          `/v1/account/accounts/${tokenDecode?.CompanyId}`
        );
        if (res?.data?.statusCode === 200) {
          const filteredData1 = res?.data?.data?.filter(
            (item) => item?.account_type === "Asset"
          );

          setAssetAccounts(filteredData1);
        }
      } catch (error) {
        console.error("Error:", error?.message);
      }
    }
  };
  useEffect(() => {
    fetchAccounts();
  }, [CompanyId]);

  const formik = useFormik({
    initialValues: {
      CompanyId: CompanyId,
      CustomerId: CustomerId,
      billing_id: "",
      card_type: "",
      customer_vault_id: "",
      cc_number: "",
      recurringId: "",
      account_id: selectedAccountId || "",
      account_name: "",
      description: "",
      amount: "",
      frequency_interval: "",
      frequency: selectedFrequency || "",
      day_of_month: "",
      weekday: "",
      day_of_year: "",
      month: "",
      days_after_quarter: "",
      IsTransactionFeePercentage: false,
    },
    validationSchema: Yup.object({
      account_id: Yup.string().required("Account is required"),
      frequency: Yup.string().required("Frequency is required"),
      amount: Yup.string()
        .required("Amount is required")
        .matches(/^\d+(\.\d{1,2})?$/, "Invalid amount format"),
      frequency_interval: Yup.number().when("frequency", {
        is: (freq) => freq === "Every N Months" || freq === "Every N Weeks",
        then: (schema) =>
          schema
            .required("Frequency interval is required")
            .min(1, "Must be at least 1"),
        otherwise: (schema) => schema.notRequired(),
      }),
      day_of_month: Yup.number().when("frequency", {
        is: (freq) => freq === "Monthly" || freq === "Every N Months",
        then: (schema) =>
          schema
            .required("Day of the month is required")
            .min(1)
            .max(28, "Day must be between 1 and 28"),
        otherwise: (schema) => schema.notRequired(),
      }),
      day_of_year: Yup.number().when("frequency", {
        is: "Yearly",
        then: (schema) =>
          schema
            .required("Day of year is required")
            .min(1)
            .max(28, "Day must be between 1 and 28"),
        otherwise: (schema) => schema.notRequired(),
      }),
      month: Yup.number().when("frequency", {
        is: "Yearly",
        then: (schema) =>
          schema
            .required("Month is required")
            .min(1)
            .max(12, "Month must be between 1 and 12"),
        otherwise: (schema) => schema.notRequired(),
      }),
      weekday: Yup.string().when("frequency", {
        is: "Weekly",
        then: (schema) => schema.required("Weekday is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      days_after_quarter: Yup.number().when("frequency", {
        is: "Quarterly",
        then: (schema) =>
          schema
            .required("Days after quarter is required")
            .min(0)
            .max(90, "Value must be between 0 and 90"),
        otherwise: (schema) => schema.notRequired(),
      }),
      IsTransactionFeePercentage: Yup.boolean().default(false),
    }),
    onSubmit: async (values) => {
      if (
        requiresSavedCard &&
        !String(values.billing_id ?? "").trim()
      ) {
        showToast.error("Please select a card");
        return;
      }
      try {
        setsubmitLoading(true);
        const dataToPost = {
          ...values,
          CompanyId: CompanyId,
          CustomerId: CustomerId,
          IsTransactionFeePercentage: applyTransactionFee,
          DejavooToken: values?.token,
          Gateway: cardGateway || tokenDecode?.Gateway,
        };
        let res;
        if (recurringChargeId) {
          res = await AxiosInstance.put(
            `/v1/recurring-payment/${recurringChargeId}`,
            dataToPost
          );

          if (res?.data?.statusCode === 200) {
            showToast.success("Recurring payment updated successfully.");
          } else {
            showToast.error(res?.data?.message);
          }
        } else {
          res = await AxiosInstance.post(
            `/v1/recurring-payment/add-cards`,
            dataToPost
          );

          if (res?.data?.statusCode === 200) {
            showToast.success("Payment added successfully.");
            // Show warning if email failed but payment was saved
            if (res?.data?.emailWarning) {
              showToast.warning(res.data.emailWarning);
            }
          } else {
            showToast.error(res?.data?.message);
          }
        }

        if (res.data.statusCode === 200) {
          formik.resetForm();
          setSelectedFrequency("");
          setSelectedAccountId("");
          setPaymentOpen(false);
          setSubmitAttempted(false);
          getTabData();
        }
      } catch (error) {
        if (error?.response && error?.response?.status === 400) {
          const errorMessages = error?.response?.data?.errors || [];
          errorMessages.forEach((errorMessage) => {
            showToast.warning(errorMessage);
          });
        } else {
          setTimeout(() => {
            showToast.error(error?.message || "An error occurred");
          }, 500);
        }
      } finally {
        getTabData();
        setsubmitLoading(false);
        setSubmitAttempted(false);
      }
    },
  });

  useEffect(() => {
    if (formik?.values?.frequency === "Yearly") {
      formik.setFieldValue("weekday", "");
      formik.setFieldValue("frequency_interval", "");
      formik.setFieldValue("day_of_month", "");
    } else if (
      formik?.values?.frequency === "Weekly" ||
      formik?.values?.frequency === "Every N Weeks"
    ) {
      formik.setFieldValue("day_of_month", "");
      formik.setFieldValue("day_of_year", "");
      formik.setFieldValue("month", "");
    } else if (formik?.values?.frequency === "Quarterly") {
      formik.setFieldValue("day_of_month", "");
      formik.setFieldValue("weekday", "");
      formik.setFieldValue("day_of_year", "");
      formik.setFieldValue("month", "");
    } else if (formik?.values?.frequency === "Monthly") {
      formik.setFieldValue("day_of_year", "");
      formik.setFieldValue("weekday", "");
      formik.setFieldValue("month", "");
    } else if (formik?.values?.frequency === "Every N Months") {
      formik.setFieldValue("weekday", "");
      formik.setFieldValue("day_of_year", "");
      formik.setFieldValue("month", "");
    }
  }, [formik?.values?.frequency]);
  const [sortField, setSortField] = useState("asc");
  const [sortOrder, setSortOrder] = useState("desc");
  const getTabData = async () => {
    setLoader(true);
    try {
      const res = await AxiosInstance.get(
        `/v1/recurring-payment/${CustomerId}`,
        {
          params: {
            pageSize: rowsPerPage,
            pageNumber: page,
            search: search || "",
            sortField: sortField,
            sortOrder: sortOrder,
            status: statusFilter === "All" ? "all" : statusFilter.toLowerCase(),
          },
        }
      );
      if (res?.data) {
        setcustomersData(res?.data?.data || []);
        setCountData(res?.data?.totalCount || 0);
      } else {
        console.error("No data received from the server.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    getTabData();
  }, [rowsPerPage, search, page, sortField, sortOrder, statusFilter, dateFormat]);

  const handleEditClick = async (id) => {
    try {
      const response = await AxiosInstance.get(
        `/v1/recurring-payment/recurring-payments/${id}`
      );
      if (response?.data?.statusCode === 200) {
        setPaymentOpen({
          isOpen: true,
          propertyData: response.data.data,
        });
        setApplyTransactionFee(
          response?.data?.data?.IsTransactionFeePercentage || false
        );

        formik.setValues({
          ...formik.values,
          account_id: response?.data?.data?.account_details?.account_id || "",
          amount: response?.data?.data?.amount || "",
          frequency: response?.data?.data?.frequency || "",
          frequency_interval: response?.data?.data?.frequency_interval || "",
          day_of_month: response?.data?.data?.day_of_month || "",
          weekday: response?.data?.data?.weekday || "",
          month: response?.data?.data?.month || "",
          account_name:
            response?.data?.data?.account_details?.account_name || "",
          day_of_year: response?.data?.data?.day_of_year || "",
          days_after_quarter: response?.data?.data?.days_after_quarter || "",
          recurringId: response?.data?.data?.recurringId || "",
          cc_number: response?.data?.data?.cc_number || "",
          billing_id: response?.data?.data?.billing_id || "",
          card_type: response?.data?.data?.card_type || "",
          customer_vault_id: response?.data?.data?.customer_vault_id || "",
          description: response?.data?.data?.description || "",
          IsTransactionFeePercentage:
            response?.data?.data?.IsTransactionFeePercentage || false,
        });
        setRecurringChargeId(response?.data?.data?.recurringId || "");
      } else {
        showToast.error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      showToast.error("Error fetching details");
    }
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async (deleteReason) => {
    if (deleteReason) {
      try {
        const response = await AxiosInstance.delete(
          `/v1/recurring-payment/deleterecpayment/${deleteId}`,
          {
            data: { DeleteReason: deleteReason },
          }
        );

        if (response?.data?.statusCode === 200) {
          showToast.success(response?.data?.message);

          setcustomersData((prevData) =>
            prevData?.filter((transactions) => transactions?.recurringId !== deleteId)
          );
        } else {
          showToast.warning(response?.data?.message);
        }
      } catch (error) {
        console.error("Error:", error);
        showToast.error(error?.message || "An error occurred");
      }
    }
    setDeleteModalOpen(false);
    setDeleteId(null);
  };

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
    setDeleteId(null);
  };
  const [addStatusOpen, setAddStatusOpen] = useState(false);
  const [statusData, setStatusData] = useState(null);

  const handleDialogOpen = () => {
    setAddStatusOpen(true);
  };

  const handleDialogClose = () => {
    setAddStatusOpen(false);
    setStatusData(null);
    setRecurringId(null);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRecurring, setSelectedRecurring] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [customSwalOpen, setCustomSwalOpen] = useState(false);

  const handleMenuClick = (e, item) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setSelectedRecurring(item);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRecurring(null);
  };

  const handleStartStopConfirmation = (item) => {
    setSelectedItem(item);
    setCustomSwalOpen(true);
  };

  const handleCustomSwalConfirm = async () => {
    if (!selectedItem) return;
    const currentIsStopRecurring = selectedItem.IsStopRecurring || false;
    try {
      setsubmitLoading(true);
      const endpoint = currentIsStopRecurring ? "start" : "stop";
      const res = await AxiosInstance.post(
        `/v1/recurring-payment/${endpoint}/${selectedItem.recurringId}`
      );
      if (res?.data?.statusCode === 200) {
        showToast.success(
          currentIsStopRecurring
            ? "Recurring donation has been started."
            : "Recurring donation has been stopped."
        );
        await getTabData();
      } else {
        showToast.error(
          res?.data?.message || "Failed to update recurring donation status"
        );
      }
    } catch (error) {
      console.error("Error updating recurring donation status:", error);
      showToast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      setsubmitLoading(false);
      handleMenuClose();
      setCustomSwalOpen(false);
      setSelectedItem(null);
    }
  };

  const handleCustomSwalClose = () => {
    setCustomSwalOpen(false);
    setSelectedItem(null);
  };

  const cellData = customersData?.map((item, index) => {
    const properties = item?.location || [];

    let propertyDisplay;
    if (properties.length === 1) {
      const property = properties[0];
      propertyDisplay = `${property?.Address || "Address not available"} ,${
        property?.City || "City not available"
      } ,${property?.State || "State not available"} ,${property?.Zip || "Zip not available"} `;
    } else {
      propertyDisplay = `${properties.length} ${
        properties?.length > 1 ? "Properties" : "Property"
      }`;
    }

    const CycleData = () => {
      if (
        item?.frequency?.toLowerCase() === "every n months" ||
        item?.frequency?.toLowerCase() === "every n weeks"
      ) {
        const frequencyValue = item?.frequency_interval;
        if (frequencyValue != null && frequencyValue !== "") {
          return item?.frequency?.replace("Every N", `Every ${frequencyValue}`);
        }
      }
      return item?.frequency || "frequency not available";
    };

    return {
      key: item?.recurringId,
      value: [
        CycleData(),
        item?.account_name || (isDonationMode ? "Donation" : "Contract Invoice"),
        item?.cc_number ?? "—",
        <div style={{ textAlign: "right" }}>
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(item?.amount || 0.0) || "amount not available"}
        </div>,
        // <div
        //   style={{
        //     whiteSpace: "nowrap",
        //     overflow: "hidden",
        //     textOverflow: "ellipsis",
        //     maxWidth: "250px",
        //     cursor: "pointer",
        //   }}
        //   title={item?.description}
        //   className="description-tooltip"
        // >
        //   {item?.description?.charAt(0).toUpperCase() +
        //     item?.description?.slice(1).toLowerCase() ||
        //     "Description not available"}
        // </div>,
        (() => {
          
          return formatDate(item?.createdAt);
        })(),
        (() => {
          
          if (item?.nextDueDate) {
            if (moment(item?.nextDueDate).isValid()) {
              return formatDate(item?.nextDueDate);
            } else {
              
              return "n/a";
            }
          } else {
            
            return "n/a";
          }
        })(),
        item?.IsStopRecurring ? (
          <div style={{ color: "red", fontWeight: "bold" }}>Stopped</div>
        ) : (
          <div style={{ color: "green", fontWeight: "bold" }}>Active</div>
        ),
        <>
          <IconButton size="small" onClick={(e) => handleMenuClick(e, item)}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={
              Boolean(anchorEl) &&
              selectedRecurring?.recurringId === item.recurringId
            }
            onClose={handleMenuClose}
            PaperProps={{
              style: {
                minWidth: "200px",
              },
            }}
          >
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleEditClick(item?.recurringId);
                handleMenuClose();
              }}
              sx={{
                gap: 1,
                display: "flex",
                alignItems: "center",
                "&:hover": { backgroundColor: "#D8E7EE" },
              }}
            >
              <EditIcon color="#0f2b46" />
              <span style={{ marginLeft: "8px" }}>Edit</span>
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(item?.recurringId);
                handleMenuClose();
              }}
              sx={{
                gap: 1,
                display: "flex",
                alignItems: "center",
                "&:hover": { backgroundColor: "#D8E7EE" },
              }}
            >
              <DeleteIcone
                className="customerEditImgToEdit"
                color="#0f2b46"
              />
              <span style={{ marginLeft: "8px" }}>Delete</span>
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleDialogOpen();
                setRecurringId(item?.recurringId);
                handleMenuClose();
              }}
              sx={{
                gap: 1,
                "&:hover": { backgroundColor: "#D8E7EE" },
              }}
            >
              <PaymentIcon fontSize="small" sx={{ color: "#0f2b46" }} />
              <span style={{ marginLeft: "8px" }}>View Donations</span>
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleStartStopConfirmation(item);
              }}
              sx={{
                gap: 1,
                "&:hover": { backgroundColor: "#D8E7EE" },
              }}
            >
              {item?.IsStopRecurring ? (
                <>
                  <PlayArrowIcon fontSize="small" sx={{ color: "#0f2b46" }} />
                  <span style={{ marginLeft: "8px" }}>Start Recurring Donation</span>
                </>
              ) : (
                <>
                  <StopIcon fontSize="small" sx={{ color: "#0f2b46" }} />
                  <span style={{ marginLeft: "8px" }}>Stop Recurring Donation</span>
                </>
              )}
            </MenuItem>
          </Menu>
        </>,
      ],
      component: item,
    };
  });

  const CollapseData = ({ data }) => {
    const fieldsToShow = [
      { label: "Days After Quarter", value: data?.days_after_quarter },
      { label: "Month", value: data?.month },
      { label: "Day of Year", value: data?.day_of_year },
      { label: "Day of Month", value: data?.day_of_month },
      { label: "Weekday", value: data?.weekday },
      { label: "Frequency Interval", value: data?.frequency_interval },
    ];

    const validFields = fieldsToShow.filter(
      (field) =>
        field?.value !== null && field?.value !== undefined && field?.value !== ""
    );
    return (
      <Grid className="d-flex gap-4 mt-3 mb-3 w-100">
        <Col className="card col-8 productDetaillTable">
          <Grid
            className="card-body w-100"
            style={{ backgroundColor: "#D8E7EE" }}
          >
            {validFields.length > 0 && (
              <Grid>
                {validFields.map((field, index) => (
                  <Grid
                    key={index}
                    className="d-flex flex-row justify-content-between gap-2 mt-1"
                  >
                    <Typography className="text-blue-color">
                      {field?.label}:{" "}
                    </Typography>
                    <Typography className="text-blue-color">
                      {field?.value}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
        </Col>
      </Grid>
    );
  };

  const handleSetCardDetails = async (item) => {
    try {
      const isDejavoo = item?.type === "dejavoo" || (item?.gateway || "").toString().toUpperCase() === "DEJAVOO";
      const cardType = isDejavoo ? (item?.cardType || item?.cc_type) : await getCardType(item?.cc_bin, item?.cc_type);
      const logoSource = item?.cardType || item?.cc_type;
      const ccNumber = item?.cc_number ?? item?.last4 ?? "****";
      const cardLogo = (isDejavoo && item?.image) ? item.image : (await getCardLogo(logoSource, ccNumber)) || null;

      return {
        billing_id: item?.billing_id || item?.["@attributes"]?.id,
        cc_number: ccNumber,
        cc_exp: item?.cc_exp,
        cc_type: item?.cc_type || item?.cardType,
        cc_bin: item?.cc_bin,
        customer_vault_id: item?.customer_vault_id || item?.vaultId,
        card_type: cardType,
        card_logo: cardLogo,
        image: item?.image || cardLogo,
      };
    } catch (error) {
      console.error(error, "error in bin check");
      return {};
    }
  };

  const [customerCards, setCustomerCards] = useState([]);
  const [selectCardDropDown, setSelectCardDropDown] = useState(false);
  const togglesCard = () => setSelectCardDropDown(!selectCardDropDown);
  const fetchRecurringCardData = async () => {
    setLoading(true);
    try {
      try {
        const cardDetails = await getCardDetails({
          CustomerId,
          type: "card",
          CompanyId,
        });

        const cards = [];
        const billingData = cardDetails?.data?.customer ?? cardDetails?.customer;
        if (!billingData) {
          return;
        }

        if (Array.isArray(billingData?.billing)) {
          const extractedData = await Promise.all(
            billingData?.billing?.map((item) => handleSetCardDetails(item))
          );
          cards.push(...extractedData.filter((item) => item));
        } else if (billingData) {
          const extractedData = await handleSetCardDetails(billingData?.billing);
          if (extractedData) cards.push(extractedData);
        }

        if (!cards.length) {
          return;
        }

        setCustomerCards(cards);

        if (recurringId) {
          const recurringData = await getRecurringCards(recurringId);

          if (recurringData && recurringData?.data) {
          } else {
          }
        } else {
          return;
        }
      } catch (customerError) {
        console.error(
          `Error processing customer ${CustomerId}: `,
          customerError
        );
      }
    } catch (error) {
      console.error("Error: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (paymentOpen) {
      fetchRecurringCardData();
    }
  }, [paymentOpen]);

  const [modalShow, setModalShow] = useState(false);
  const [isPublicKeyAvailable, setIsPublicKeyAvailable] = useState(false);
  const getNmiKey = async (Company_Id) => {
    try {
      const keyResponse = await getTokenizationKeyCustomer(Company_Id);
      if (keyResponse?.PublicKey) {
        setIsPublicKeyAvailable(true);
      } else {
        setIsPublicKeyAvailable(false);
      }
    } catch (error) {
      console.error(error?.message);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const CompanyId = getItem("DonorId");
      await getNmiKey(CompanyId);
    };
    fetchData();
  }, []);

  return (
    <>
      <RecurringPayment
        loader={loader}
        navigate={navigate}
        SinglecardToggle={SinglecardToggle}
        search={search}
        setSearch={setSearch}
        page={page}
        CollapseData={CollapseData}
        setRowsPerPage={setRowsPerPage}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        formik={formik}
        paymentOpen={paymentOpen}
        setSelectedAccountId={setSelectedAccountId}
        setSelectedFrequency={setSelectedFrequency}
        addBankAccountDialogOpen={addBankAccountDialogOpen}
        setAddBankAccountDialogOpen={setAddBankAccountDialogOpen}
        AssetAccounts={AssetAccounts}
        toggles1={toggles1}
        selectChargeDropDown={selectChargeDropDown}
        toggleWeekdayDropdown={toggleWeekdayDropdown}
        weekdayDropdownOpen={weekdayDropdownOpen}
        toggleFrequencyDropdown={toggleFrequencyDropdown}
        frequencyDropdownOpen={frequencyDropdownOpen}
        fetchAccounts={fetchAccounts}
        setPaymentOpen={setPaymentOpen}
        cellData={cellData}
        countData={countData}
        customerCards={customerCards}
        selectCardDropDown={selectCardDropDown}
        togglesCard={togglesCard}
        loading={loading}
        isPublicKeyAvailable={isPublicKeyAvailable}
        setModalShow={setModalShow}
        modalShow={modalShow}
        CustomerId={CustomerId}
        CompanyId={CompanyId}
        fetchRecurringCardData={fetchRecurringCardData}
        submitloading={submitloading}
        companyName={companyName}
        recurringChargeId={recurringChargeId}
        setRecurringChargeId={setRecurringChargeId}
        setSortField={setSortField}
        setSortOrder={setSortOrder}
        sortOrder={sortOrder}
        sortField={sortField}
        isDonationMode={isDonationMode}
        transactionFeePercentage={transactionFeePercentage}
        applyTransactionFee={applyTransactionFee}
        handleTransactionFeeChange={handleTransactionFeeChange}
        dateFormat={dateFormat}
        tokenDecode={tokenDecode}
        submitAttempted={submitAttempted}
        setSubmitAttempted={setSubmitAttempted}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
      />
      <DialogComponent
        addStatusOpen={addStatusOpen}
        handleDialogClose={handleDialogClose}
        setStatusData={setStatusData}
        statusData={statusData}
        recurringId={recurringId}
        isDonationMode={isDonationMode}
      />
      <CustomSwal
        isOpen={deleteModalOpen}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        title="Delete Recurring Payment"
        text="Are you sure you want to delete this recurring payment? This action cannot be undone."
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
        placeholder="Enter reason for deletion"
        requireInput={true}
        isDonationMode={isDonationMode}
      />
      <CustomSwal
        isOpen={customSwalOpen}
        onClose={handleCustomSwalClose}
        onConfirm={handleCustomSwalConfirm}
        isDonationMode={isDonationMode}
        title={
          selectedItem?.IsStopRecurring
            ? "Start Recurring Donation?"
            : "Stop Recurring Donation?"
        }
        text={
          selectedItem?.IsStopRecurring
            ? "Are you sure you want to start this recurring donation?"
            : "Are you sure you want to stop this recurring donation?"
        }
        confirmButtonText={
          selectedItem?.IsStopRecurring ? "Yes, Start it!" : "Yes, Stop it!"
        }
        cancelButtonText="Cancel"
        placeholder="Enter reason for this action"
        requireInput={false}
      />
    </>
  );
}

export default RecurringPayments;
